<template>
  <div class="box">
    <div class="banner">
      <img :src="banner" alt="">
      <div class="league-text">
      </div>
    </div>
    <div v-if="!isSubmit">
        <div class="banner">
          <img :src="step" alt="">
        </div>
        <div class="re-sub">
          <div class="re-sub-box">
            <div class="submit fl">
              <div class="sub-item">
                <div class="sub-item-fl fl">试用业务:</div>
                <div class="sub-item-fr fl">
                  <span @click="selectSYS(3)" :class="selectIndex==3?'bgColor':''">导游管理系统</span>
                  <span @click="selectSYS(1)" :class="selectIndex==1?'bgColor':''">购物管理系统</span>
                  <!-- <span @click="selectSYS(1)" :class="selectIndex==1?'bgColor':''">趣旅淘系统</span> -->
                  <span @click="selectSYS(4)" :class="selectIndex==4?'bgColor':''">应急救援系统</span>
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl">单位名称:</div>
                <div class="sub-item-fr fl">
                  <input type="text" v-model="unitName">
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl">联系人姓名:</div>
                <div class="sub-item-fr fl">
                  <input type="text" v-model="name">
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl">联系人微信:</div>
                <div class="sub-item-fr fl">
                  <input type="text" v-model="wx">
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl">联系人电话:</div>
                <div class="sub-item-fr fl">
                  <input type="text" v-model="mobile">
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl">备注说明:</div>
                <div class="sub-item-fr fl" style="margin-bottom: 10px;">
                  <textarea rows="7"  placeholder="请输入200字以内" cols="49" style="padding-left: 4px;padding-top: 6px;width:372px;" v-model="remarks"></textarea>
                </div>
              </div>
              <div class="sub-item">
                <div class="sub-item-fl fl"></div>
                <div class="sub-item-fr fl">
                  <div style="position:relative;">
                    <input type="checkbox" @click="isAgree" id="checkbox-id" name="" value="1" style="width:16px;height:16px;margin-bottom:10px;" >
                    <p style="position:absolute;width:200px; top:1px;left:22px;">已阅读并同意使用此协议</p>
                  </div>
                  <div class="sub-btn" :class="state?'btnBg':''" @click="subMit">下一步</div>
                </div>
              </div>
            </div>
            <div class="protocol fl">
              <!-- <span>{{agreementArr.content}}</span> -->
              <div class="protocol-head">{{agreementArr.title}}</div>
              <div class="protocol-content"></div>
            </div>
          </div>
        </div>
    </div>
    <div v-if="isSubmit">
        <div class="banner">
          <img :src="step_2" alt="">
        </div>
        <div class="msg-box">
          <div class="msg">
            <div class="img">
              <img :src="succeed" alt="">
            </div>
            <div class="sn">业务单号：{{subArr.applySn}}</div>
            <div class="tip">{{msg}}</div>
          </div>
        </div>

    </div>

  </div>
</template>

<script>
  import global_ from './../store/global'

export default {

  name: 'League',
  data () {
    return {
      app: global_.app,
      platform: global_.platform,
      ver: global_.ver,
      sendSelected:'league',
      colourClass:'',
      banner:global_.imgUrl+'contact_us.jpg',
      step: global_.imgUrl+'contact_step.jpg',
      step_2: global_.imgUrl+'contact_step_2.jpg',
      succeed: global_.imgUrl+'succeed_2.png',
      ApplicationFormIcon: global_.imgUrl+'ApplicationFormIcon2.',
      href:'#/league/register',
      agreementArr:'',
      subArr:{},
      msg:'',
      selectIndex:1,
      sysTtype:1,
      state:false,
      isSubmit:false,
      unitName:'',
      name:'',
      wx:'',
      mobile:'',
      remarks:'',
      isChecked:'0',
      content:''
    }
  },
  created() {
    if(this.$route.query.sysTtype){
      this.selectIndex = this.$route.query.sysTtype;
    }

  },
  methods:{
    selectSYS(val){
      this.selectIndex=val
      this.getAgreement(this.selectIndex)
    },
    isAgree(){
      this.state=!this.state
    },
    subMit() {
      if ($('#checkbox-id').prop("checked")) {
        if (this.unitName=='') {
          layer.msg('请输入单位名称');
          return;
        }
        if (this.name=='') {
          layer.msg('请输入联系人姓名');
          return;
        }
        if (!/^\d{11}$/.test(this.mobile)) {
          layer.msg('请输入正确的手机号');
          return;
        }
        this.isChecked=1;
        let self = this;
        layer.load(2);
        let formData = new FormData();
        formData.append("applyType", this.selectIndex);
        formData.append("compName", this.unitName);
        formData.append("linkName", this.name);
        formData.append("linkWeixin", this.wx);
        formData.append("linkPhone", this.mobile);
        formData.append("demo", this.remarks);
        formData.append("isChecked", this.isChecked);
        formData.append("app", this.app);
        formData.append("platform", this.platform);
        formData.append("ver", this.ver);
        self.$ajax.post(self.wbBkApplyLogSubmitHttp, formData).then(
          function(res) {
            layer.closeAll("loading");
            console.log('res',res)

            let code = res.data.code;
            let result = res.data.result;
            if (code === "10000") {
              self.msg=res.data.message
              self.subArr=result
              self.isSubmit=true
            } else {
              layer.msg(res.data.message)
            }
          },
          function(res) {
            layer.closeAll("loading");
            layer.msg("服务器错误！");
            self.pieces = 0;
          }
        );
      }else{
        console.log('N')
      }
    },



    getAgreement(applyType) {
      let self = this;
      layer.load(2);
      let formData = new FormData();
      formData.append("applyType",applyType);
      formData.append("app", 'xingchengzhushou');
      formData.append("platform", 'web');
      formData.append("ver", '3');
      self.$ajax.post(self.getAgreementHttp, formData).then(
        function(res) {
          layer.closeAll("loading");
          let code = res.data.code;
          let result = res.data.result;
          if (code === "10000") {
            self.agreementArr=result.Agreement
            var item=self.agreementArr.content

            self.content = item.replace(/。/g, "。<br>");
            // var content = item.replace(/；/g, "<br>");
            // var content = item.replace(/\s+/g, "<br>");
            // $(".protocol").html(content).appendTo($(span));
            $(".protocol-content").html(self.content)

          } else {
             self.content=''
          }
        },
        function(res) {
          layer.closeAll("loading");
          layer.msg("获取协议出错！");
          self.pieces = 0;
        }
      );
    },

  },
  computed: {
    wbBkApplyLogSubmit() {
      return this.$store.state.interface.wbBkApplyLogSubmit;
    },
    agreement() {
      return this.$store.state.interface.getAgreement;
    },
  },
  beforeMount(){
    var session=sessionStorage.getItem('GWcustomer');
    var session='3go1vjcnis0rtc043j0ei9iqm1ebor4o'
    if(session!=null){
      this.href='#/league/information';
    }
    this.wbBkApplyLogSubmitHttp = `${this.wbBkApplyLogSubmit}?sid=${session}`;
    this.getAgreementHttp = `${this.agreement}?sid=${session}`;
    this.getAgreement(this.selectIndex)
  },
  mounted(){
    this.$emit('nav',this.sendSelected,this.colourClass);
  },

}
</script>

<style lang="scss" scoped>
  .banner{
    width: 100%;
    min-width: 1200px;
    position: relative;
    overflow: hidden;
    img{
      width: 1920px;
      max-width: inherit;
      position: relative;
      left: 50%;
      top: 0;
      margin-left: -960px;
    }
    .league-text{
      position: absolute;
      width: 1200px;
      height: 100%;
      top: 0;
      left: 50%;
      margin-left: -600px;
      text-align: center;
      h6{
        margin-top: 110px;
        color: #fff;
        font-size: 46px;
        line-height: 48px;
      }
      .JoinUs-Btn{
        display: block;
        width: 200px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border-radius: 10px;
        margin: 0 auto;
        font-size: 24px;
        color: #fff;
        margin-top: 40px;
        border: 1px solid #fff;
        &:hover{
          background-color: #fff;
          color: #ff8c00;
        }
      }
    }
  }
  .indexCase{
    margin: 80px 0 140px;
    .indexTitle-box{
      margin-bottom: 40px;
      text-align: center;
      .indexTitle{
        font-size: 32px;
        font-weight: bold;
        color: #333;
        line-height: 40px;
      }
      .indexSubtitle{
        font-size: 24px;
        color: #999;
        line-height: 32px;
        font-weight: normal;
        text-transform:uppercase;
        margin: 5px 0;
      }
    }
    .indexService{
      margin: 60px 0 0;
      display: flex;
      .indexService-li{
        // flex-grow: 1;
        text-align: center;
        width: 25%;
        img{
          display: block;
          margin: 30px auto 20px;
        }
        .advantage-text{
          margin: 0 20px;
          h6{
            font-size: 20px;
            line-height: 28px;
            color: #333;
            margin-bottom: 10px;
            // text-indent: 15px;
          }
          p{
            font-size: 14px;
            line-height: 24px;
            color: #999;
          }
        }

      }
    }

  }
  .ApplicationForm{
    // background: url('../assets/images/ApplicationForm2.jpg') center center no-repeat;
    background-size: 1920px auto;
    width: 100%;
    min-width: 1200px;
    .indexCase{
      margin: 100px 0 200px;
    }


  }
  .re-sub{
    width: 100%;
    height: 580px;
    .re-sub-box{
      width: 1250px;
      height: 470px;
      margin: 0px auto;

      .submit{
        width: 520px;
        height: 470px;
        .sub-item{
          margin-left: 40px;

          .sub-item-fl{
            width: 75px;
            height: 40px;
            text-align: right;
            line-height: 40px;
            margin-right: 10px;
             margin-bottom: 10px;
          }
          .sub-item-fr{
             margin-bottom: 30px;
            span{
              width: 110px;
              height: 40px;
              line-height: 40px;
              color: #fff;
              text-align: center;
              display: inline-block;
              background-color: #cccccc;
              margin-right: 15px;
              border-radius: 4px;
              cursor:pointer;
            }
            input{
              width: 372px;
              height: 40px;
              box-shadow: none;
              border: 1px solid #a9a9a9;
              padding-left: 4px;
            }
            .sub-btn{
              width: 100px;
              height: 40px;
              color: #fff;
              line-height: 40px;
              margin-top: 10px;
              text-align: center;
              cursor: pointer;
              border-radius: 4px;
              background-color: #c1c1c1;
              // background-color: #09ba79;
            }
            .btnBg{
              background-color: #09ba79;
            }
            .bgColor{
              background-color: #09ba79;
            }
          }
        }
      }

      .protocol{
        width: 690px;
        height: 451px;
        line-height: 25px;
        border: 1px solid #09ba79;
        overflow-y: auto;
        .protocol-head{
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: 900;
        }
        .protocol-content{
          width: 100%;
          height: 100%;
          text-indent:30px
        }
      }
    }
  }
        .msg-box{
        width: 100%;
        height: 400px;
        position: relative;
        line-height: 30px;
        text-align: center;
        .msg{
          position: absolute;
          height: 200px;
          width: 330px;
          top: 0px;
          left: 0px;
          right: 0px;
          bottom: 50px;
          margin:auto;
          img{
            margin: 0px 100px;
          }
          .sn{
            margin-top: 15px;
            color: #09ba79;
          }
          .tip{
            color: #999999;
          }
        }
      }
</style>



// WEBPACK FOOTER //
// src/components/league.vue